import { render, staticRenderFns } from "./Template9new.vue?vue&type=template&id=1488d0f6&scoped=true&"
import script from "./Template9new.vue?vue&type=script&lang=js&"
export * from "./Template9new.vue?vue&type=script&lang=js&"
import style0 from "./Template9new.vue?vue&type=style&index=0&id=1488d0f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488d0f6",
  null
  
)

export default component.exports